enum HeightUnit {
    Meter,
    Inch,
    Centimeter
}

enum WeightUnit {
    Kilogram,
    Pound,
    Gram
}

enum TemperatureUnit {
    Celsius,
    Fahrenheit
}

enum BloodGlucoseConcentrationUnit {
    milligramPerDecilitre,  // mg / dL
    millimolesPerLitre // mmol / L
}

enum SerumCreatinineConcentrationUnit {
    micromolesPerLitre, // μmol/L
    milligramsPer100millilitre // mg/100ml
}

export { BloodGlucoseConcentrationUnit, HeightUnit, SerumCreatinineConcentrationUnit, TemperatureUnit, WeightUnit };
